import { render, staticRenderFns } from "./QrCodeLogoBase64.vue?vue&type=template&id=012d7650&scoped=true"
import script from "./QrCodeLogoBase64.vue?vue&type=script&lang=js"
export * from "./QrCodeLogoBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d7650",
  null
  
)

export default component.exports